import { render, staticRenderFns } from "./RuleSelector.vue?vue&type=template&id=56c99e8f&scoped=true&"
import script from "./RuleSelector.vue?vue&type=script&lang=js&"
export * from "./RuleSelector.vue?vue&type=script&lang=js&"
import style0 from "./RuleSelector.vue?vue&type=style&index=0&id=56c99e8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c99e8f",
  null
  
)

export default component.exports